import React from "react";
import Description from "../UserInterface/Description";
import Images from "../UserInterface/Images";
import LayoutCenter from "../UserInterface/LayoutCenter";

type GoIllusListProps = {
  illusList: Array<{ imageUrl: string; descText: string }>;
};
const GoIllusList = ({ illusList }: GoIllusListProps) => {
  return (
    <>
      <LayoutCenter margin="0px">
        <div className="terms-wrapper">
          {illusList.map((item, idx) => {
            return (
              <div className="terms-items" key={idx}>
                <Images
                  mobileWidth="64px"
                  margin="0px"
                  width="140px"
                  url={item.imageUrl}
                ></Images>
                <Description
                  text={item.descText}
                  font="Roboto"
                  fontMobile="14px"
                ></Description>
              </div>
            );
          })}
        </div>
        <style jsx>{`
          .terms-items {
            width: 140px;
            display: flex;
            flex-direction: column;
            align-items: center;
            margin: 0px 10px;
          }
          .terms-wrapper {
            width: 100%;
            display: flex;
            justify-content: space-around;
          }
          @media only screen and (max-width: 600px) {
            .terms-items {
              width: 140px;
            }
            .terms-wrapper {
              flex-direction: column;
              align-items: center;
            }
          }
        `}</style>
      </LayoutCenter>
    </>
  );
};

export default GoIllusList;
